// extracted by mini-css-extract-plugin
export default {"formCombinedBlock":"FormCombinedBlock_formCombinedBlock__M0fYK"};